/* eslint-disable */
import axios from 'axios';

/**
 * Convenience class for storing things obtained from the info.json
 */
export default class ImageInfo {
  constructor(iiifInfo) {
    this.id = iiifInfo['@id'];
    this.sizes = iiifInfo['sizes'];
    this.width = iiifInfo['width'];
    this.height = iiifInfo['height'];
  }

  // original
  // getThumbnailUrl() {
  //   let availableWidths = this.sizes.map((size) => size.width);

  //   const minAvailableWidth = Math.min(...availableWidths);
  //   return `${this.id}/full/${minAvailableWidth},/0/default.jpg`;
  // }
  getThumbnailUrl() {
    const thumbnailWidth = 150; // Specify the desired width for the thumbnail

    let availableWidths = this.sizes.map((size) => size.width);

    // Find the closest available width to the desired thumbnail width
    const closestWidth = availableWidths.reduce((prev, curr) =>
      Math.abs(curr - thumbnailWidth) < Math.abs(prev - thumbnailWidth) ? curr : prev
    );

    return `${this.id}/full/${closestWidth},/0/default.jpg`;
  }
}

export function fetchImageInfo(iiifUrl) {
  return axios.get(iiifUrl);
}

// export function fetchImageInfos(iiifUrls) {
//   const imageInfoRequests = iiifUrls.map((iiifUrl) => fetchImageInfo(iiifUrl));

//   return Promise.all(imageInfoRequests).then((response) => {
//     const imageInfos = [];

//     response.forEach((response) => {
//       imageInfos.push(new ImageInfo(response.data));
//     });

//     return imageInfos;
//   });
// }

export async function fetchImageInfos(iiifUrls) {
  const imageInfos = [];
  const firstImageUrl = iiifUrls[0];

  try {
    const firstImageResponse = await fetchImageInfo(firstImageUrl);
    const firstImageInfo = new ImageInfo(firstImageResponse.data);
    imageInfos.push(firstImageInfo);
  } catch (error) {
    console.error(`Error fetching image info for ${firstImageUrl}:`, error);
  }

  const remainingUrls = iiifUrls.slice(1);
  const remainingImagePromises = remainingUrls.map((iiifUrl) =>
    fetchImageInfo(iiifUrl).then((response) => new ImageInfo(response.data))
  );

  const remainingImageResults = await Promise.allSettled(remainingImagePromises);

  remainingImageResults.forEach((result) => {
    if (result.status === 'fulfilled') {
      imageInfos.push(result.value);
    } else {
      console.error('Error fetching an image info:', result.reason);
    }
  });

  return imageInfos;
}
